import { call, put, select, take, takeEvery } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'

import * as actions from './timer.actions'
import * as selectors from './timer.selectors'

const tickInterval = () => {
  return eventChannel((emitter) => {
    const interval = setInterval(() => {
      emitter('tick')
    }, actions.STEP)
    return () => {
      clearInterval(interval)
    }
  })
}

/**
 *  Process each tick
 */
export function* processTick() {
  const timers = yield select(selectors.getTimers)

  for (let timerId in timers) {
    const timer = timers[timerId]
    if (timer && timer.remaining <= 0) {
      yield put({ type: actions.EXPIRE, data: timerId })
    }
  }
}

/**
 *  Timer sagas
 */
export function* sagas() {
  yield takeEvery(actions.TICK, processTick)

  const channel = yield call(tickInterval)
  /* eslint no-constant-condition: 0 */
  while (true) {
    yield take(channel)
    let timers = yield select(selectors.getTimers)

    if (Object.keys(timers).length > 0) {
      yield put({ type: actions.TICK })
    }
  }
}
